<template>
	<v-container class="robots none-fluid">
		<banner>Robots</banner>
		<anchor-bar :data="robots" />
		<br />
		<v-expansion-panels multiple v-model="panels" class="mx-auto robots-content">
			<v-expansion-panel
				v-for="section in robots"
				:key="section.title"
				expand
				:id="section.title.replace(/\s/gi, '-')"
			>
				<v-expansion-panel-header class="expansion-header">{{ section.title }}</v-expansion-panel-header>
				<v-expansion-panel-content class="expansion-content">
					<div v-for="(robot, i) in section.children" :key="robot.subtitle" class="expansion-subsection">
						<h4 v-if="robot.subtitle" class="expansion-subtitle">{{ robot.subtitle }}</h4>
						<v-row v-if="robot.image.length === 1">
							<v-col cols="12" lg="3">
								<img :src="robot.image[0]" :alt="robot.subtitle" class="robot-image" />
							</v-col>
							<v-col cols="12" lg="8">
								<p v-html="$sanitize(robot.content)"></p>
							</v-col>
						</v-row>
						<v-row v-else>
							<v-col cols="12" lg="5">
								<img
									v-for="image in robot.image"
									:src="image"
									:alt="image"
									:key="image"
									class="robot-image-multiple"
								/>
							</v-col>
							<v-col cols="12" lg="6">
								<p v-html="$sanitize(robot.content)"></p>
							</v-col>
						</v-row>
						<v-divider v-if="i !== section.children.length - 1"></v-divider>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import AnchorBar from "../global/AnchorBar";
import { getAllRobots } from "../../service/about/robots";

export default {
	components: {
		Banner,
		AnchorBar
	},
	data() {
		return {
			robots: [],
			panels: [],
			arrow: false
		};
	},
	mounted() {
		getAllRobots()
			.then(robots => {
				this.robots = robots;
				for (let i = 0; i < robots.length; ++i) {
					this.panels.push(i);
				}
			})
			.catch(err => {
				console.error(err.message);
			});
	}
};
</script>

<style lang="scss">
.robots {
	.robot-image {
		display: block;
		max-width: 80%;
		max-height: 300px;
		margin-left: auto;
		margin-right: auto;
	}

	.robot-image-multiple {
		display: inline-block;
		width: 50%;
		padding: 20px;
		max-height: 300px;
	}
}
</style>
